/**
 * AWE GA4 Analytics – shared event helper.
 *
 * Guards against gtag not being present, matching the pattern already used
 * by awe-shop-the-look.js's shop_the_look_clicked tracking. Both
 * awe-nav-tracking.js and awe-shop-the-look.js call this instead of each
 * rolling their own gtag guard.
 */
(function () {
  'use strict';

  /**
   * @param {string} name - GA4 event name
   * @param {Object} params - Event params
   * @param {{beacon?: boolean}} [options]
   */
  function fireGA4Event(name, params, options) {
    if (typeof window.gtag !== 'function') return;
    var payload = Object.assign({}, params);
    if (options && options.beacon) {
      payload.transport_type = 'beacon';
    }
    window.gtag('event', name, payload);
  }

  window.aweFireGA4Event = fireGA4Event;
})();
